<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '130px' : '130px'"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户姓名" prop="name">
            <el-input v-model="dataForm.name" placeholder="客户姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
         

          <el-form-item  label="城市" prop="city">
              <el-select  v-model="dataForm.city" filterable clearable placeholder="请选择城市">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>

      </el-form-item>

        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" :disabled="dataForm.id" placeholder="手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="申请金额" prop="money">
            <el-input
              v-model="dataForm.money"
              placeholder="申请金额"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="落地页" prop="pageId">
            <el-select
              v-model="dataForm.pageId"
              clearable
              filterable
              placeholder="请选择落地页"
            >
              <el-option
                v-for="item in pages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代运营机构" prop="operationId">
            <el-select
              v-model="dataForm.operationId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in operationList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="渠道" prop="channelId">
            <el-select
              v-model="dataForm.channelId"
              clearable
              filterable
              placeholder="请选择渠道"
            >
              <el-option
                v-for="item in channels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="dataForm.sex" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款业务类型" prop="businessType">
            <el-select
              v-model="dataForm.businessType"
              clearable
              filterable
              placeholder="请选择贷款业务类型"
            >
              <el-option
                v-for="item in businessTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="状态" prop="status">
            <el-select v-model="dataForm.status" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年齢" prop="age">
            <el-input v-model="dataForm.age" placeholder="年齢"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号码" prop="cardNo">
            <el-input
              v-model="dataForm.cardNo"
              placeholder="身份证号码"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="返回信息" prop="returnMsg">
            <el-input
              v-model="dataForm.returnMsg"
              placeholder="返回信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="个性化字段信息" prop="bundle">
            <el-input
              v-model="dataForm.bundle"
              placeholder="个性化字段信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="落地页url" prop="url">
            <el-input v-model="dataForm.url" placeholder="落地页url"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="是否推送" prop="isPush">
            <el-select v-model="dataForm.isPush" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in isPushs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="推送内容" :disabled="dataForm.id" prop="pushMsg">
            <el-input
              v-model="dataForm.pushMsg"
              :disabled="dataForm.id"
              placeholder="推送内容"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属公司" prop="companyId">
            <el-select
              v-model="dataForm.companyId"
              clearable
              filterable
              placeholder="请选择公司"
            >
              <el-option
                v-for="item in companys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8"> </el-col>
        <el-col :span="8"> </el-col>
        <el-col :span="8"> </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="职业" prop="professional">
            <el-input
              v-model="dataForm.professional"
              placeholder="职业"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="就业时长" prop="employmentTime">
            <el-input
              v-model="dataForm.employmentTime"
              placeholder="就业时长"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="月收入" prop="monthlyIncome">
            <el-input
              v-model="dataForm.monthlyIncome"
              placeholder="月收入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="工资发放形式" prop="payrollType">
            <el-input
              v-model="dataForm.payrollType"
              placeholder="工资发放形式"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款用途" prop="useFor">
            <el-input
              v-model="dataForm.useFor"
              placeholder="贷款用途"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款期限" prop="loanLongTime">
            <el-input
              v-model="dataForm.loanLongTime"
              placeholder="贷款期限"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="信用情况" prop="creditSituation">
            <el-input
              v-model="dataForm.creditSituation"
              placeholder="信用情况"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="信用卡" prop="isCredit">
            <el-input
              v-model="dataForm.isCredit"
              placeholder="信用卡"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="社保" prop="shebao">
            <el-select style="width: 100%;" v-model="dataForm.shebao" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in shebaoList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="公积金" prop="gongjijin">
            <el-select style="width: 100%;" v-model="dataForm.gongjijin" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in shebaoList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车产" prop="car">
            <el-select style="width: 100%;" v-model="dataForm.car" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in houseList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车况" prop="carType">
            <el-input
              v-model="dataForm.carType"
              placeholder="车况（新车|二手车）"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="车型" prop="carModel">
            <el-input v-model="dataForm.carModel" placeholder="车型"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆年限" prop="carLife">
            <el-input
              v-model="dataForm.carLife"
              placeholder="车辆年限"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商业保险" prop="baodanIs">
            <el-input
              v-model="dataForm.baodanIs"
              placeholder="商业保险"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="芝麻信用" prop="zmScore">
            <el-select style="width: 100%;" v-model="dataForm.zmScore" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in zmScoreList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="微粒贷" prop="weili">
            <el-input v-model="dataForm.weili" placeholder="微粒贷"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业主" prop="businessLicense">
            <el-input
              v-model="dataForm.businessLicense"
              placeholder="企业主"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="房产" prop="house">
            <el-select style="width: 100%;" v-model="dataForm.house" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in houseList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房屋类型" prop="houseType">
            <el-input
              v-model="dataForm.houseType"
              placeholder="房屋类型"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房屋面积" prop="houseSize">
            <el-input
              v-model="dataForm.houseSize"
              placeholder="房屋面积"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="房屋年限" prop="houseLife">
            <el-input
              v-model="dataForm.houseLife"
              placeholder="房屋年限"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="数据来源" prop="ip">
            <el-input v-model="dataForm.ip" placeholder="数据来源"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="号码归属地" prop="telLocation">
            <el-input
              v-model="dataForm.telLocation"
              placeholder="号码归属地"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="IP所在地" prop="leadsArea">
            <el-input
              v-model="dataForm.leadsArea"
              placeholder="IP所在地"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址" prop="address">
            <el-input
              v-model="dataForm.address"
              placeholder="详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="教育程度" prop="education">
            <el-input
              v-model="dataForm.education"
              placeholder="教育程度"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="门店名称" prop="shopName">
            <el-input
              v-model="dataForm.shopName"
              placeholder="门店名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="门店地址" prop="shopAddress">
            <el-input
              v-model="dataForm.shopAddress"
              placeholder="门店地址"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="leadsEmail">
            <el-input
              v-model="dataForm.leadsEmail"
              placeholder="邮箱"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="qq号" prop="leadsQq">
            <el-input v-model="dataForm.leadsQq" placeholder="qq号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="微信号" prop="leadsWechat">
            <el-input
              v-model="dataForm.leadsWechat"
              placeholder="微信号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="账户ID" prop="accountId">
            <el-input
              v-model="dataForm.accountId"
              placeholder="账户ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账户名称" prop="accountName">
            <el-input
              v-model="dataForm.accountName"
              placeholder="账户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="广告组ID" prop="adgroupId">
            <el-input
              v-model="dataForm.adgroupId"
              placeholder="广告组ID"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="广告组名称" prop="adgroupName">
            <el-input
              v-model="dataForm.adgroupName"
              placeholder="广告组名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="推广计划ID" prop="adsId">
            <el-input
              v-model="dataForm.adsId"
              placeholder="推广计划ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="推广计划名称" prop="adsName">
            <el-input
              v-model="dataForm.adsName"
              placeholder="推广计划名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="创意ID" prop="creativeId">
            <el-input
              v-model="dataForm.creativeId"
              placeholder="创意ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="广告创意" prop="creativeName">
            <el-input
              v-model="dataForm.creativeName"
              placeholder="广告创意"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交易ID" prop="transId">
            <el-input
              v-model="dataForm.transId"
              placeholder="交易ID"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="婚姻状况" prop="isMarried">
            <el-select
              v-model="dataForm.isMarried"
              clearable
              filterable
              placeholder="请选择婚姻状况"
            >
              <el-option
                v-for="item in marrieds"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租机台数" prop='mobileLeaseQuantity'>
            <el-input
              v-model="dataForm.mobileLeaseQuantity"
              placeholder="租机台数"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
     
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      visible: false,
      operationList: [],
      companys: [],
      channels: [],
      pages: [],
      shebaoList:[],
      houseList:[],
      zmScoreList:[],
      isPushs: [
        {
          label: "未推送",
          value: 0,
        },
        {
          label: "已推送",
          value: 1,
        },
      ],
      sexList: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      statusList: [
        {
          label: "有效",
          value: 1,
        },
        {
          label: "无效",
          value: 0,
        },
      ],
      marrieds: [
        {
          label: "未婚",
          value: 1,
        },
        {
          label: "已婚",
          value: 2,
        },
      ],
      businessTypes:[
        {
          label:"综合贷（信贷）",
          value:"综合贷（信贷）"
        },
         {
          label:"房贷",
          value:"房贷"
        },
         {
          label:"车贷",
          value:"车贷"
        }
      ],
      citys:[],
      dataForm: {
        mobileLeaseQuantity: '',
        id: "",
        name: "",
        sex: "",
        mobile: "",
        telLocation: "",
        age: "",
        cardNo: "",
        operationId: "",
        channelId: "",
        companyId: "",
        pageId: "",
        ip: "",
        leadsArea: "",
        city: "",
        url: "",
        isPush: "",
        pushMsg: "",
        pushDate: "",
        pushStatus: "",
        returnMsg: "",
        address: "",
        bundle: "",
        isMarried: "",
        education: "",
        professional: "",
        employmentTime: "",
        monthlyIncome: "",
        payrollType: "",
        money: "",
        useFor: "",
        loanLongTime: "",
        creditSituation: "",
        isCredit: "",
        shebao: "",
        gongjijin: "",
        car: "",
        carType: "",
        carModel: "",
        carLife: "",
        baodanIs: "",
        zmScore: "",
        weili: "",
        businessLicense: "",
        house: "",
        houseType: "",
        houseSize: "",
        houseLife: "",
        shopName: "",
        shopAddress: "",
        leadsEmail: "",
        leadsQq: "",
        leadsWechat: "",
        status: "",
        remark: "",
        accountId: "",
        accountName: "",
        adgroupId: "",
        adgroupName: "",
        adsId: "",
        adsName: "",
        creativeId: "",
        creativeName: "",
        createBy: "",
        createTime: "",
        updateBy: "",
        updateTime: "",
        deleteTime: "",
        transId: "",
        businessTypes:"",
      },
    };
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        money:[
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        operationId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        channelId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        pageId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        leadsEmail: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // {
          //   pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
          //   message: "请输入正确的手机号码或者座机号",
          // },
        ],
        // mobile: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        //   {
        //     pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
        //     message: "请输入正确的手机号码",
        //   },
        // ],
        cardNo: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
          },
        ],
      };
    },
  },
  methods: {
    async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
    init() {
      this.getOperatorsOptions();
      this.getCompanysOptions();
      this.getchannelsOptions();
      this.getPageOptions();
      this.getCityOptions();
      this.getZmScore();
      this.getShebao();
      this.getHouse();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/customersth/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },
    //初始化芝麻分下拉框的选项
    async getZmScore() {
     this.$http.get(`/sys/dict/data/list?dataType=zmScore`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.zmScoreList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.zmScoreList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化社保下拉框的选项
    async getShebao() {
     this.$http.get(`/sys/dict/data/list?dataType=shebao`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.shebaoList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.shebaoList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化房产下拉框的选项
    async getHouse() {
     this.$http.get(`/sys/dict/data/list?dataType=house`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.houseList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.houseList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化运营机构下拉框的选项
    async getOperatorsOptions() {
      this.$http
        .get(`/sys/operations/listAll`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.operationList = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.operationList.push({
                label: element.name,
                value: element.id,
              });
            });
          }
        })
        .catch(() => {});
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http
        .get(`/sys/channels/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.channels = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.channels.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http
        .get(`/sys/landingpages/list`)
        .then(({ data: res }) => {
         
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.pages = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.pages.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$unblank(this.dataForm)
          
          this.$http[!this.dataForm.id ? "post" : "put"](
            "/sys/customersth/",
            this.dataForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
